import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
  color: #172033;
}

.access-shell {
  --navy: #071525;
  --navy-soft: #0d2035;
  --mint: #4de0c0;
  --blue: #2878ff;
  min-height: 100vh;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  position: relative;
  overflow: hidden;
  background: var(--navy);
}

.ambient {
  position: absolute;
  border-radius: 999px;
  pointer-events: none;
  filter: blur(2px);
}

.ambient-one {
  width: 520px;
  height: 520px;
  left: -260px;
  bottom: -270px;
  background: radial-gradient(circle, rgba(31, 120, 255, 0.22), transparent 67%);
}

.ambient-two {
  width: 620px;
  height: 620px;
  right: 280px;
  top: -430px;
  background: radial-gradient(circle, rgba(77, 224, 192, 0.14), transparent 67%);
}

.product-story {
  min-height: 100vh;
  padding: 40px clamp(44px, 5vw, 84px) 30px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  color: #fff;
}

.story-header,
.mobile-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-mark {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: var(--navy);
  background: var(--mint);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.14) inset;
}

.brand-mark svg {
  width: 28px;
  height: 28px;
}

.brand-copy {
  display: grid;
  line-height: 1.1;
}

.brand-copy strong {
  font-size: 14px;
  letter-spacing: 0.08em;
}

.brand-copy span {
  margin-top: 4px;
  color: #8094aa;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.15em;
}

.story-copy {
  max-width: 720px;
  margin-top: clamp(44px, 7vh, 74px);
}

.eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #73e7ce;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.18em;
}

.eyebrow-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--mint);
  box-shadow: 0 0 0 5px rgba(77, 224, 192, 0.12);
}

.story-copy h1 {
  margin: 19px 0 15px;
  font-size: clamp(38px, 4vw, 58px);
  line-height: 1.18;
  letter-spacing: -0.045em;
  font-weight: 700;
}

.story-copy p {
  max-width: 590px;
  margin: 0;
  color: #9cafc1;
  font-size: 14px;
  line-height: 1.75;
}

.product-preview {
  width: min(780px, 100%);
  margin-top: clamp(28px, 4vh, 46px);
  border: 1px solid rgba(151, 178, 202, 0.2);
  border-radius: 18px;
  overflow: hidden;
  background: rgba(11, 31, 51, 0.82);
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.32);
  backdrop-filter: blur(18px);
}

.preview-header {
  min-height: 58px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(151, 178, 202, 0.14);
}

.preview-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.preview-title > div:last-child {
  display: grid;
}

.vehicle-thumb {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  color: #7dd3fc;
  border: 1px solid rgba(125, 211, 252, 0.2);
  border-radius: 9px;
  background: rgba(45, 148, 213, 0.1);
}

.vehicle-thumb svg {
  width: 24px;
  height: 24px;
}

.preview-title strong {
  font-size: 12px;
  font-weight: 600;
}

.preview-title span {
  margin-top: 3px;
  color: #71869a;
  font-size: 9px;
}

.live-status {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #64e6ca;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.live-status span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--mint);
  box-shadow: 0 0 0 4px rgba(77, 224, 192, 0.1);
}

.agent-flow {
  min-height: 68px;
  padding: 10px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(151, 178, 202, 0.12);
  background: rgba(5, 18, 32, 0.4);
}

.agent-item {
  min-width: 70px;
  display: grid;
  justify-items: center;
  gap: 5px;
  color: #65798d;
  font-size: 9px;
}

.agent-icon {
  width: 25px;
  height: 25px;
  display: grid;
  place-items: center;
  border: 1px solid #31465a;
  border-radius: 50%;
  font-size: 9px;
}

.agent-icon svg {
  width: 14px;
  height: 14px;
}

.agent-item.complete {
  color: #70e1c9;
}

.agent-item.complete .agent-icon {
  border-color: rgba(77, 224, 192, 0.44);
  background: rgba(77, 224, 192, 0.09);
}

.agent-item.current {
  color: #fff;
}

.agent-item.current .agent-icon {
  border-color: #4f9dff;
  background: rgba(40, 120, 255, 0.13);
  box-shadow: 0 0 0 4px rgba(40, 120, 255, 0.08);
}

.agent-pulse {
  width: 7px;
  height: 7px;
  border: 2px solid #75b4ff;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

.flow-line {
  width: clamp(25px, 5vw, 58px);
  height: 1px;
  margin: 0 3px 16px;
  background: #2a3d50;
}

.flow-line.active {
  background: linear-gradient(90deg, var(--mint), #438dfa);
}

.preview-body {
  min-height: 224px;
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(145px, 0.72fr);
}

.preview-visual {
  min-height: 224px;
  position: relative;
  overflow: hidden;
  border-right: 1px solid rgba(151, 178, 202, 0.12);
}

.visual-grid {
  position: absolute;
  inset: 0;
  opacity: 0.13;
  background-image: linear-gradient(rgba(130, 170, 200, 0.35) 1px, transparent 1px), linear-gradient(90deg, rgba(130, 170, 200, 0.35) 1px, transparent 1px);
  background-size: 24px 24px;
  transform: perspective(260px) rotateX(60deg) scale(1.4) translateY(34px);
  transform-origin: bottom;
}

.vehicle-wire {
  width: 92%;
  height: 94%;
  position: absolute;
  left: 3%;
  bottom: 1%;
  color: #79a0bb;
  filter: drop-shadow(0 10px 24px rgba(0, 0, 0, 0.2));
}

.axis-label {
  width: 20px;
  height: 20px;
  position: absolute;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #061727;
  font-size: 9px;
  font-weight: 800;
}

.label-a {
  top: 43%;
  right: 19%;
  background: #fb923c;
}

.label-b {
  top: 18%;
  right: 10%;
  background: var(--mint);
}

.preview-metrics {
  padding: 14px;
  display: grid;
  gap: 8px;
  background: rgba(8, 25, 42, 0.45);
}

.metric-card {
  padding: 10px 12px;
  display: grid;
  align-content: center;
  position: relative;
  border: 1px solid rgba(151, 178, 202, 0.13);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.025);
}

.metric-card > span {
  color: #6e8397;
  font-size: 8px;
}

.metric-card strong {
  margin-top: 3px;
  color: #f4f8fb;
  font-size: 19px;
  font-weight: 650;
  letter-spacing: -0.03em;
}

.metric-card small {
  margin-left: 3px;
  color: #7d91a5;
  font-size: 8px;
  font-weight: 500;
}

.metric-card em {
  position: absolute;
  right: 9px;
  bottom: 9px;
  color: #5eead4;
  font-size: 7px;
  font-style: normal;
}

.preview-foot {
  min-height: 50px;
  padding: 8px 15px;
  display: flex;
  align-items: center;
  gap: 9px;
  border-top: 1px solid rgba(151, 178, 202, 0.12);
  background: rgba(12, 39, 61, 0.7);
}

.agent-avatar {
  width: 26px;
  height: 26px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 8px;
  color: #062035;
  background: linear-gradient(135deg, #5eead4, #60a5fa);
  font-size: 8px;
  font-weight: 800;
}

.preview-foot p {
  margin: 0;
  color: #89a0b4;
  font-size: 9px;
}

.preview-foot strong {
  margin-right: 4px;
  color: #d8e5ef;
  font-weight: 600;
}

.trust-row {
  width: min(780px, 100%);
  margin-top: auto;
  padding-top: 22px;
  display: flex;
  justify-content: space-between;
  color: #42586d;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.login-panel {
  min-height: 100vh;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  color: #172033;
  background: #fff;
  box-shadow: -24px 0 70px rgba(0, 0, 0, 0.14);
}

.login-top {
  height: 72px;
  padding: 0 clamp(28px, 3.8vw, 58px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  color: #98a1ae;
  font-size: 10px;
  letter-spacing: 0.04em;
}

.login-top button {
  width: 24px;
  height: 24px;
  border: 1px solid #dfe4ea;
  border-radius: 50%;
  color: #728093;
  background: #fff;
  font-size: 11px;
}

.login-content {
  width: min(390px, 100% - 56px);
  margin: auto;
  transform: translateY(-17px);
}

.mobile-brand {
  display: none;
  margin-bottom: 40px;
}

.mobile-brand .brand-mark {
  color: #fff;
  background: #1266e8;
}

.mobile-brand strong {
  font-size: 14px;
  letter-spacing: 0.08em;
}

.secure-badge {
  width: fit-content;
  padding: 6px 9px;
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 7px;
  color: #226456;
  background: #eafaf6;
  font-size: 9px;
  font-weight: 650;
}

.secure-badge svg {
  width: 14px;
  height: 14px;
}

.login-heading h2 {
  margin: 17px 0 7px;
  color: #101827;
  font-size: 29px;
  font-weight: 750;
  letter-spacing: -0.04em;
}

.login-heading p {
  margin: 0;
  color: #7a8492;
  font-size: 12px;
}

.account-picker {
  margin-top: 28px;
}

.account-picker-head {
  margin-bottom: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #3c4655;
  font-size: 11px;
  font-weight: 650;
}

.account-picker-head em {
  padding: 3px 6px;
  border-radius: 5px;
  color: #23816e;
  background: #eafaf6;
  font-size: 7px;
  font-style: normal;
  font-weight: 750;
  letter-spacing: 0.1em;
}

.account-list {
  display: grid;
  gap: 8px;
}

.account-card,
.account-skeleton {
  width: 100%;
  min-height: 62px;
  padding: 9px 12px;
  display: flex;
  align-items: center;
  gap: 11px;
  border: 1px solid #e1e6ec;
  border-radius: 11px;
  color: #172033;
  background: #fff;
}

.account-card {
  text-align: left;
  cursor: pointer;
  transition: border-color 0.18s, box-shadow 0.18s, transform 0.18s, background 0.18s;
}

.account-card:hover:not(:disabled),
.account-card:focus-visible {
  border-color: #73a4ed;
  outline: 0;
  background: #fbfdff;
  box-shadow: 0 6px 18px rgba(31, 101, 180, 0.09);
  transform: translateY(-1px);
}

.account-card:disabled {
  cursor: wait;
}

.account-card:disabled:not(.loading) {
  opacity: 0.52;
}

.account-card.loading {
  border-color: #5592e8;
  background: #f7fbff;
  box-shadow: 0 0 0 3px rgba(49, 113, 215, 0.09);
}

.account-avatar {
  width: 39px;
  height: 39px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 11px;
  color: #166454;
  background: #d9f7ef;
  font-size: 13px;
  font-weight: 750;
}

.account-avatar[data-color=blue] {
  color: #245caa;
  background: #e1edff;
}

.account-avatar[data-color=violet] {
  color: #6d4a9d;
  background: #eee7fa;
}

.account-copy {
  min-width: 0;
  display: grid;
  flex: 1;
  gap: 3px;
}

.account-copy strong {
  color: #1d2737;
  font-size: 12px;
  font-weight: 700;
}

.account-copy small {
  overflow: hidden;
  color: #8993a0;
  font-size: 9px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-action {
  width: 24px;
  height: 24px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 7px;
  color: #8794a4;
  background: #f3f6f9;
}

.account-card:hover:not(:disabled) .account-action,
.account-card:focus-visible .account-action,
.account-card.loading .account-action {
  color: #246bd7;
  background: #eaf2ff;
}

.account-action svg {
  width: 15px;
  height: 15px;
}

.account-action i {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(36, 107, 215, 0.28);
  border-top-color: #246bd7;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.credential-switch,
.back-to-accounts {
  display: flex;
  align-items: center;
  border: 0;
  color: #3971c4;
  background: transparent;
  font-family: inherit;
  font-size: 10px;
  font-weight: 650;
  cursor: pointer;
}

.credential-switch {
  width: 100%;
  margin-top: 16px;
  justify-content: center;
  gap: 7px;
}

.credential-switch svg,
.back-to-accounts svg {
  width: 15px;
  height: 15px;
}

.credential-switch:disabled,
.back-to-accounts:disabled {
  cursor: wait;
  opacity: 0.55;
}

.back-to-accounts {
  margin: -3px 0 22px;
  padding: 0;
  gap: 5px;
}

.account-skeleton {
  overflow: hidden;
  position: relative;
}

.account-skeleton::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.72), transparent);
  animation: shimmer 1.2s infinite;
}

.account-skeleton > i {
  width: 39px;
  height: 39px;
  flex: 0 0 auto;
  border-radius: 11px;
  background: #edf1f5;
}

.skeleton-copy {
  display: grid;
  flex: 1;
  gap: 7px;
}

.skeleton-copy span {
  width: 30%;
  height: 8px;
  border-radius: 999px;
  background: #edf1f5;
}

.skeleton-copy span:last-child {
  width: 62%;
  height: 7px;
}

.account-skeleton > b {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background: #edf1f5;
}

.account-error {
  min-height: 92px;
  padding: 18px;
  display: grid;
  place-items: center;
  gap: 9px;
  border: 1px dashed #d8e0e8;
  border-radius: 11px;
  background: #fafbfd;
}

.account-error p {
  margin: 0;
  color: #7f8997;
  font-size: 10px;
}

.account-error button {
  padding: 5px 9px;
  border: 1px solid #b8c9df;
  border-radius: 6px;
  color: #3971c4;
  background: #fff;
  font-family: inherit;
  font-size: 9px;
  font-weight: 650;
  cursor: pointer;
}

.login-form {
  margin-top: 34px;
}

.field-label,
.password-head {
  color: #3c4655;
  font-size: 11px;
  font-weight: 650;
}

.password-head {
  margin-top: 19px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-button {
  border: 0;
  color: #3171d7;
  background: transparent;
  font-size: 10px;
  font-weight: 600;
}

.field-wrap {
  height: 47px;
  margin-top: 7px;
  display: flex;
  align-items: center;
  position: relative;
  border: 1px solid #dce2e9;
  border-radius: 10px;
  color: #9aa5b3;
  background: #fbfcfd;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.field-wrap:focus-within {
  border-color: #4a83e1;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(49, 113, 215, 0.1);
}

.field-wrap > svg {
  width: 18px;
  height: 18px;
  margin-left: 14px;
  flex: 0 0 auto;
}

.field-wrap input {
  width: 100%;
  height: 100%;
  min-width: 0;
  padding: 0 14px 0 10px;
  border: 0;
  outline: 0;
  color: #152033;
  background: transparent;
  font-family: inherit;
  font-size: 12px;
}

.field-wrap input::placeholder {
  color: #aab3bf;
}

.password-toggle {
  width: 43px;
  height: 100%;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border: 0;
  color: #8c98a7;
  background: transparent;
}

.password-toggle svg {
  width: 18px;
  height: 18px;
}

.remember-row {
  width: fit-content;
  margin-top: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #667181;
  font-size: 10px;
  cursor: pointer;
}

.remember-row input {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  accent-color: #1f6ee8;
}

.login-button {
  width: 100%;
  height: 49px;
  margin-top: 25px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border: 0;
  border-radius: 10px;
  color: #fff;
  background: linear-gradient(135deg, #1672ef, #2856d9);
  box-shadow: 0 9px 22px rgba(31, 101, 223, 0.2);
  font-family: inherit;
  font-size: 12px;
  font-weight: 650;
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 12px 26px rgba(31, 101, 223, 0.28);
}

.login-button:disabled {
  cursor: wait;
  opacity: 0.72;
}

.login-button svg {
  width: 17px;
  height: 17px;
}

.button-loading {
  display: flex;
  align-items: center;
  gap: 8px;
}

.button-loading i {
  width: 13px;
  height: 13px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.support-note {
  margin-top: 28px;
  padding: 13px 14px;
  display: flex;
  gap: 10px;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  background: #f9fafc;
}

.support-icon {
  width: 27px;
  height: 27px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 7px;
  color: #55708e;
  background: #eaf0f6;
}

.support-icon svg {
  width: 16px;
  height: 16px;
}

.support-note p {
  margin: 0;
  color: #8993a0;
  font-size: 9px;
  line-height: 1.55;
}

.support-note strong {
  display: block;
  margin-bottom: 2px;
  color: #4d5969;
  font-size: 10px;
  font-weight: 650;
}

.login-footer {
  min-height: 62px;
  padding: 0 clamp(28px, 3.8vw, 58px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  color: #a0a8b3;
  font-size: 8px;
}

.footer-links {
  display: flex;
  gap: 15px;
}

.footer-links a {
  color: inherit;
  text-decoration: none;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes shimmer {
  to {
    transform: translateX(100%);
  }
}
@media (max-width: 1100px) {
  .access-shell {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .product-story {
    padding-right: 38px;
    padding-left: 38px;
  }
  .story-copy h1 {
    font-size: 40px;
  }
  .preview-body {
    grid-template-columns: 1fr;
  }
  .preview-metrics {
    grid-template-columns: repeat(3, 1fr);
    border-top: 1px solid rgba(151, 178, 202, 0.12);
  }
  .preview-visual {
    min-height: 176px;
    border-right: 0;
  }
}
@media (max-width: 820px) {
  .access-shell {
    display: block;
    background: #fff;
  }
  .product-story {
    display: none;
  }
  .login-panel {
    min-height: 100vh;
    box-shadow: none;
  }
  .mobile-brand {
    display: flex;
  }
  .login-top {
    padding: 0 24px;
  }
  .login-content {
    width: min(390px, 100% - 40px);
    transform: none;
  }
  .login-footer {
    padding: 14px 24px;
  }
}
@media (max-height: 790px) and (min-width: 821px) {
  .product-story {
    padding-top: 28px;
    padding-bottom: 22px;
  }
  .story-copy {
    margin-top: 30px;
  }
  .story-copy h1 {
    font-size: 39px;
  }
  .product-preview {
    margin-top: 22px;
  }
  .agent-flow {
    min-height: 56px;
  }
  .preview-body,
  .preview-visual {
    min-height: 190px;
  }
  .trust-row {
    display: none;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public showPassword: boolean = false;
    public showCredentialLogin: boolean = false;
    public submitting: boolean = false;
    public accountsLoading: boolean = true;
    public accountsError: boolean = false;
    public selectedAccountKey: string = '';
    public accounts: any[] = [];

    public data: any = {
        email: '',
        password: ''
    };

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/";
        await this.loadAccounts();
    }

    public async loadAccounts() {
        this.accountsLoading = true;
        this.accountsError = false;
        await this.service.render();

        try {
            let { code, data } = await wiz.call("accounts", {});
            if (code == 200) {
                this.accounts = data.accounts || [];
            } else {
                this.accountsError = true;
            }
        } catch (error) {
            this.accountsError = true;
        }

        this.accountsLoading = false;
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async loginAccount(account: any) {
        if (this.submitting) return;

        this.submitting = true;
        this.selectedAccountKey = account.key;
        await this.service.render();

        try {
            let { code, data } = await wiz.call("login_account", {
                account_key: account.key
            });

            if (code == 200) {
                location.href = "/";
                return;
            }

            await this.alert(data.message || "계정 로그인에 실패했습니다.", 'error');
        } catch (error) {
            await this.alert("로그인 요청 중 오류가 발생했습니다.", 'error');
        }

        this.submitting = false;
        this.selectedAccountKey = '';
        await this.service.render();
    }

    public async toggleCredentialLogin(show: boolean) {
        if (this.submitting) return;
        this.showCredentialLogin = show;
        this.data.password = '';
        await this.service.render();
    }

    public async togglePassword() {
        this.showPassword = !this.showPassword;
        await this.service.render();
    }

    public async login() {
        if (this.submitting) return;

        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        // user.password = this.service.auth.hash(user.password);

        this.submitting = true;
        await this.service.render();

        try {
            let { code, data } = await wiz.call("login", user);

            if (code == 200) {
                location.href = "/";
                return;
            }

            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        } catch (error) {
            await this.alert("로그인 요청 중 오류가 발생했습니다.", 'error');
        }

        this.submitting = false;
        await this.service.render();
    }
}

export default PageAccessComponent;